<template>
  <div>
    <cube-popup
      ref="myPopup"
      :visible.sync="TipDialogVisible"
      type="my-popup"
      class="bind-dialog"
      position="center"
      :mask="false"
      :center="false"
    >
      <div class="merge-form">
        <cube-form
          :model="model"
          @validate="validateHandler"
          @submit.prevent="submitHandler"
          @reset="resetHandler"
        >
          <cube-form-item :field="fields[0]" />
          <cube-form-item :field="fields[1]" />
          <div class="form-btn-box">
            <cube-button
              type="reset"
              :light="true"
            >
              {{ $t('message["896"]') }}
            </cube-button>
            <cube-button
              type="submit"
              :primary="true"
            >
              {{ $t('message["915"]') }}
            </cube-button>
          </div>
        </cube-form>
      </div>
    </cube-popup>
    <bind-tips-dialog
      ref="tipsDialog"
      :value="model.username"
      :type-error="typeError"
    />
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import BindTipsDialog from './BindTipsDialog'
import { setAuth } from '@/lib/storage'
export default {
  components: {
    BindTipsDialog
  },
  props: {
    bindType: {
      type: String,
      default: ''
    },
    value: {
      type: String,
      default: ''
    },
    visible: {
      type: Boolean,
      default: false
    }
    // userid: {
    //   type: Number,
    //   default: 0
    // }
  },
  data () {
    return {
      validity: {},
      TipDialogVisible: false,
      valid: undefined,
      model: {
        username: '',
        password: ''
      },
      typeError: {},
      isTipDShow: false,
      options: {
        scrollToInvalidField: true,
        layout: 'fresh' // classic fresh
      },
      fields: [
        {
          type: 'input',
          modelKey: 'username',
          label: this.$t('message["1565"]'),
          props: {
            placeholder: this.$t('message["202"]')
          },
          rules: {
            required: true
          }
        },
        {
          type: 'input',
          modelKey: 'password',
          label: this.$t('message["632"]'),
          props: {
            placeholder: this.$t('message["762"]'),
            type: 'password'
          },
          rules: {
            required: true
          }
        }
      ]
    }
  },
  computed: {
    ...mapActions('merge', ['ajaxNoNotice']),
    baseinfo () {
      return this.$store.state.baseinfo
    }
  },
  mounted () {
  },
  methods: {
    ...mapActions('merge', ['ajaxSave']),
    changeLimitDialog (b) {
      this.TipDialogVisible = b
    },
    async submitHandler (val) {
      const chain = await this.ajaxSave()
      chain.params(this.model)
        .onSuccess(res => {
          this.TipDialogVisible = false
          setAuth(res.Authorization)
          this.$store.commit('setAuth', res.Authorization, { root: true })
          this.$router.push({ name: 'OrgIndex' })
        })
        .onNetSuccess(raw => {
          const res = raw.data
          if (res.error === 104 || (res.error === 105)) {
            this.typeError = res
            this.TipDialogVisible = false
            this.$refs.tipsDialog.changeLimitDialog(true)
          } else {
            const toast = this.$createToast({
              time: 2000,
              txt: res.message || res.payload[0].message,
              type: 'txt'
            })
            toast.show()
          }
        })
        .config({ tip: false, warn: false })
        .setForm(this.form)
        .fetch()
      // this.TipDialogVisible = false
    },
    validateHandler (result) {
      this.validity = result.validity
      this.valid = result.valid
    },
    showPopup (refId) {
      const component = this.$refs[refId]
      component.show()
    },
    resetHandler () {
      this.$refs.myPopup.hide()
    }
  }
}
</script>
<style lang="scss" scoped>
.merge-form {
 width: 100%;
 height: 100%;
 background: #f5f5f5;
}
.bind-dialog::v-deep {
  background: #f5f5f5;
  .cube-popup-content {
    width: 100%;
    height: 100%;
  }
}
</style>
